import { FC, useEffect, useState } from 'react';
import { Select } from '@app/form_components';
import { Option } from '@app/types';
import { useServices } from '../../hooks';
import './bannerForm.scss';

export const SelectAnchor: FC<any> = ({ context }) => {
  const { appConfigService } = useServices();

  const designId = window.apm.serialized.designId;

  const selectedAnchorKey = 'bannerAnchor';

  const selectedAnchor = context.getConfig(selectedAnchorKey) || '';

  const [anchors, setAnchors] = useState<Option<string>[] | null>(null);

  useEffect(() => {
    const getAnchors = async () => {
      const anchors = await appConfigService.getAnchors(designId);

      setAnchors(Option.fromIdAndName(anchors));
    };

    getAnchors();
  }, [selectedAnchor]);

  const onChange = (newValue: string) => {
    context.setConfig(selectedAnchorKey, newValue);
    const nodeId = context.hasWriteProxy()
      ? context.id
      : context.props.parentComponentID;
    window.apm.updateParentNode(
      context,
      nodeId,
      selectedAnchorKey,
      newValue,
      context.type,
      selectedAnchor
    );
    document.dispatchEvent(new CustomEvent('ev-property-refresh'));
  };

  if (!anchors) {
    return null;
  }

  return (
    <div className="form-component-container">
      <Select
        label="Banner Anchor"
        name="bannerAnchor"
        onChange={(value) => onChange(value ?? '')}
        options={anchors}
        placeholder="- Select a Banner Anchor -"
        value={selectedAnchor || null}
      />
    </div>
  );
};
